<template>
  <div>
      <div class="title"> About </div>
      <div class="content">
            Hi and welcome.

            <br>
            <br>
          
            This is a personal blog of sorts; a collection of various personal obessions and things I find interesting. 
            Sometimes I when have a question or idea or thought that I want to explore and fulfill, I will sit down and do the math, then
            write a small program to visualize my results. 
            
            <br>
            <br>
            This blog also serves to document my journey as a programmer. For example, this site was created very innocently, using 
            a simple system of html files and native javascript with no outside libraries. It is now a single page app using Vue, and
            also makes use of some helpful JS frameworks in my projects, such as p5.js and MathJax.

            <br><br><br><br><br><br>
            Below, I'd like to share some of my favorite things on the internet.

            <div style="display: flex; flex-direction: column"> 
                <p class="quote subheading"> One of my favorite teachers </p>
                <iframe width="687" height="515" src="https://www.youtube.com/embed/IIDLcaQVMqw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                <p class="quote subheading"> My favorite YouTube video from the channel 3Blue1Brown </p>
                <iframe width="916" height="515" src="https://www.youtube.com/embed/HEfHFsfGXjs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.subheading {
    width: fit-content;
}

</style>
